import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingRegionSwitcher } from "./RacingRegionSwitcher";
import { RacingRegionSwitcherData } from "./data";
let _;
let PageMethodsMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-legacy-integration/lib-esm/mocks");
    PageMethodsMock = _.PageMethodsMock;
}
export class RacingRegionSwitcherRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new RacingRegionSwitcherData(new PageMethodsMock());
            // setup dictionary for debug build
            this.options.dict = BaseDict;
            //export data store to window for debug purposes
            window["RacingRegionSwitcherDATA"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingRegionSwitcherData(options.dataProvider);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    activate() {
        return super.activate(React.createElement(RacingRegionSwitcher, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
}
window["RacingRegionSwitcher"] = RacingRegionSwitcherRoot;
broadcastBlockLoad("RacingRegionSwitcher");
//# sourceMappingURL=index.js.map